<span (click)="click()"
      tooltip="{{(disabled ? 'This button is blocked, please review and correct fields' : '') | translate}}"
      class="btn btn-primary mr-2 mt-2 mt-md-0 align-self-center {{buttonClass ? buttonClass : ''}} {{selected? 'text-button--primary-selected' : ''}}
{{noLeftPadding ? 'text-button--no-left-padding' : ''}} {{disabled? 'text-button--disabled' : ''}}
{{noRightMargin ? '' : 'mr-2'}}">
  <ng-content></ng-content>
</span>